import { enStatus } from './course';

export enum enCommentType {
  html = 'html',
  rawText = 'rawText'
}
export interface IComment {
  createdAt: string;
  id: number;
  status: enCommentStatus;
  fixed?: boolean;
  text: string;
  totalReplies?: number;
  replies?: IComment[];
  user: {
    avatar: string;
    id: number;
    name: string;
  };
  type: enCommentType;
}

export interface IConfigComment {
  id: number;
  userId: number;
  replyStudent: boolean;
  replyStudentAll: boolean;
  hasAvatar: boolean;
  avatarImage: string;
  avatarName: string;
  isAutoPublish: boolean;
  isAutoPublishAll: boolean;
  ia: boolean;
  hasStatus: boolean;
  timeToRespond: boolean;
  timeToRespondMessage: string;
  isReplyStudent: boolean;
}

export enum enCommentStatus {
  waitingAproval,
  public,
  private
}

export interface ICommentCourse {
  createdAt: string;
  id: number;
  lessonId: number;
  lessonTitle: string;
  moduleTitle: string;
  status: enStatus;
  fixed?: boolean;
  text: string;
  commentType: string;
}
